module.exports = ".btn-icon {\n  width: 36px; }\n\n.btn-detail-row {\n  float: right;\n  margin: 16px;\n  margin-right: 8.5em; }\n\n.filter-column, .dropdown-column {\n  padding-bottom: 5px; }\n\n.filter-row {\n  padding-bottom: 10px; }\n\n.tablediv {\n  padding-right: 5px;\n  padding-left: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/views/my-publication-view/my-publication-view.component.scss
// module id = ./src/app/+app-custom/views/my-publication-view/my-publication-view.component.scss
// module chunks = main